import React from "react";
import styles from "./CourseLockedBottomSheet.module.scss";
import Button from "@src/components/UIElements/Button";
import { Image } from "@src/components/Image";
import Modal from "@src/components/UIElements/Modal";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import * as actionCreator from "../../store/actions";
import { getAwsAssets } from "@src/utils";
import { useTranslation } from "react-i18next";
import RoundLockIcon from "../../../AccentIcons/RoundLockIcon";

const CourseLockedBottomSheet = ({
  src,
  mainText,
  subText,
  btnText,
  btnAction,
  viewAllSubText,
  boldSubText,
  showBtn,
  state = false,
  dispatcher = false,
  isCloseButtonVisible= true,
  customClasses = {
    btnText: "",
    viewAllSubText:"",
    parentContainer:""
  },
  iconColor = "",
  showSuccessBtn,
  successBtnText,
  successBtnAction,
  isUserSubscribedToFreeCourse
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const courseData = useSelector(
    (state) => state.bottomSheetReducer?.showCourseLockedBottomSheet
  );

  const handleClose = () => {
    localStorage.removeItem("currentItem");
    if (dispatcher) {
      dispatcher();
    } else {
      dispatch(actionCreator.showCourseLockedBottomSheetAction(false));
    }
  };
  const handleSuccessButtonClicked = () => {
    successBtnAction && successBtnAction();
  };

  const handleButtonClicked = () => {
    // alert("handleButtonClicked");
    // console.log(btnAction);
    btnAction && btnAction();
  };

  return (
    <Modal showModal={state} handleClose={handleClose} isCloseButtonVisible={isCloseButtonVisible}>
      <div className={`${styles.CourseLocked} ${customClasses?.parentContainer}`}>
        <div className={styles.CourseLocked__image}>
          <RoundLockIcon color={iconColor}/>
        </div>
        <h1 className={styles.CourseLocked__heading}>{mainText}</h1>
        <p className={styles.CourseLocked__subtext}>
          {subText}
          {boldSubText && <span>{boldSubText}</span>}
        </p>

        {showSuccessBtn && !isUserSubscribedToFreeCourse ? (
          <Button  onClick={handleSuccessButtonClicked}>{successBtnText}</Button>
        ) : (
          ""
        )}

        {showBtn ? (
          isUserSubscribedToFreeCourse || !showSuccessBtn ? (
            <Button customClassName={customClasses?.btnText} onClick={handleButtonClicked}>
              {btnText}
            </Button>
          ) : (
            <Button style={{ color: "#009AE0", backgroundColor: "white" }} onClick={handleButtonClicked}>
              {btnText}
            </Button>
          )
        ) : ""}

        <p className={`${styles.CourseLocked__viewAllInst} ${customClasses?.viewAllSubText}`} onClick={handleClose}>
          {viewAllSubText}
        </p>
      </div>
    </Modal>
  );
};

export default CourseLockedBottomSheet;
